import React, { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, updateDoc, doc, deleteDoc, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../config';
import { useAuth } from '../context/AuthContext';
import HeaderMapper from '../utils/headerMapping';
import { Task } from '../types/task';
import TaskListManager from '../components/TaskListManager';
import AddTaskForm from '../components/AddTaskForm';
import DocumentViewer from '../components/DocumentViewer';
import ExcelDetailView from '../components/ExcelDetailView';
import FullExcelEditor from '../components/FullExcelEditor';
import DailyTaskReport from '../components/DailyTaskReport';
import { directExcelNotification } from '../services/directExcelNotification';
import awsS3Service from '../services/awsS3Service';

// Excel Assign Tasks Content Component
const ExcelAssignTasksContent: React.FC<{
  excelAssignedTasks: any[];
  onViewExcel: (task: any) => void;
  onRefresh: () => void;
  user: any;
  fetchExcelAssignedTasksFromNotifications: () => Promise<void>;
}> = ({ excelAssignedTasks, onViewExcel, onRefresh, user, fetchExcelAssignedTasksFromNotifications }) => {
  console.log('📊 ExcelAssignTasksContent - Received tasks:', excelAssignedTasks.length);
  console.log('📊 ExcelAssignTasksContent - Task details:', excelAssignedTasks.map(task => ({
    id: task.id,
    sheetName: task.sheetName,
    headers: task.headers,
    dataKeys: Object.keys(task.data || {}),
    dataValues: Object.values(task.data || {})
  })));

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">📊 Excel Assign Tasks</h2>
          <p className="text-sm text-gray-500">Tasks assigned to you from Excel workbooks</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onRefresh}
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
          >
            🔄 Refresh
          </button>
          {/* <button
            onClick={async () => {
              console.log('🧪 Testing notification creation...');
              if (!user?.uid) {
                alert('❌ No user logged in. Please log in first.');
                return;
              }
              try {
                // Test direct notification
                await directExcelNotification.sendDirectExcelNotification(
                  user.uid,
                  {
                    headers: ['Particulars', 'Concerned Person', 'Status', 'Priority', 'Due Date'],
                    rows: [['Test Task', user.displayName || 'Test User', 'TO-DO', 'Medium', '2025-01-01']],
                    sheetName: 'Test Sheet',
                    workbookId: 'test-item-456'
                  },
                  'Test Admin',
                  0
                );
                console.log('✅ Test direct notification sent successfully!');
                alert('✅ Test direct notification sent! Check console for details.');
                
                // Refresh the notifications list immediately
                console.log('🔄 Refreshing notifications list...');
                await fetchExcelAssignedTasksFromNotifications();
              } catch (error) {
                console.error('❌ Test notification failed:', error);
                alert('❌ Test notification failed. Check console for details.');
              }
            }}
            className="inline-flex items-center px-4 py-2 border border-blue-300 rounded-md shadow-sm text-sm font-medium text-blue-700 bg-blue-50 hover:bg-blue-100"
          >
            🧪 Test Notification
          </button>
          <button
            onClick={() => {
              console.log('🔍 AWS S3 Configuration Check:');
              console.log('AWS S3 Configured:', awsS3Service.isConfigured());
              console.log('Environment Variables:');
              console.log('- REACT_APP_AWS_ACCESS_KEY_ID:', process.env.REACT_APP_AWS_ACCESS_KEY_ID ? '✅ Set' : '❌ Missing');
              console.log('- REACT_APP_AWS_SECRET_ACCESS_KEY:', process.env.REACT_APP_AWS_SECRET_ACCESS_KEY ? '✅ Set' : '❌ Missing');
              console.log('- REACT_APP_S3_BUCKET_NAME:', process.env.REACT_APP_S3_BUCKET_NAME ? '✅ Set' : '❌ Missing');
              console.log('- REACT_APP_AWS_REGION:', process.env.REACT_APP_AWS_REGION || 'us-east-1 (default)');
              alert(`AWS S3 Status: ${awsS3Service.isConfigured() ? '☁️ Configured' : '❌ Not Configured'}\nCheck console for details.`);
            }}
            className="inline-flex items-center px-4 py-2 border border-green-300 rounded-md shadow-sm text-sm font-medium text-green-700 bg-green-50 hover:bg-green-100"
          >
            🔍 Check AWS S3
          </button>
          <button
            onClick={async () => {
              if (!user?.uid) {
                alert('❌ No user logged in. Please log in first.');
                return;
              }
              console.log('🔍 Debug: Listing all notifications for user:', user.uid);
              try {
                const notifications = await directExcelNotification.getUserExcelNotifications(user.uid);
                console.log('📊 All notifications for user:', notifications);
                console.log('📊 Notification count:', notifications.length);
                notifications.forEach((notification, index) => {
                  console.log(`📋 Notification ${index + 1}:`, {
                    id: notification.id,
                    type: notification.type,
                    title: notification.title,
                    message: notification.message,
                    read: notification.read,
                    createdAt: notification.createdAt,
                    excelData: notification.excelData
                  });
                });
                alert(`Found ${notifications.length} notifications for user ${user.uid}. Check console for details.`);
              } catch (error) {
                console.error('❌ Error listing notifications:', error);
                alert('❌ Error listing notifications. Check console for details.');
              }
            }}
            className="inline-flex items-center px-4 py-2 border border-purple-300 rounded-md shadow-sm text-sm font-medium text-purple-700 bg-purple-50 hover:bg-purple-100"
          >
            🔍 List Notifications
          </button> */}
          {/* {process.env.NODE_ENV === 'development' && (
            <>
              <button
                onClick={async () => {
                  console.log('🧪 TEST: Manually triggering fetchExcelAssignedTasks...');
                  await onRefresh();
                }}
                className="inline-flex items-center px-3 py-1.5 border border-blue-300 rounded text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100"
              >
                🧪 Test
              </button>
              <button
                onClick={async () => {
                  console.log('🧪 TEST: Creating fake assignment for testing...');
                  // Create a fake assignment in the first workbook/sheet
                  const workbooksQuery = query(collection(db, 'excelWorkbooks'));
                  const workbooksSnapshot = await getDocs(workbooksQuery);
                  
                  if (workbooksSnapshot.docs.length > 0) {
                    const firstWorkbook = workbooksSnapshot.docs[0];
                    const workbookData = firstWorkbook.data();
                    console.log('📋 First workbook found:', workbookData.workbookName);
                    
                    if (workbookData.sheets && workbookData.sheets.length > 0) {
                      const firstSheet = workbookData.sheets[0];
                      console.log('📄 First sheet found:', firstSheet.name);
                      
                      // Add a fake assignment row
                      let sheetData = firstSheet.data;
                      if (typeof sheetData === 'string') {
                        sheetData = JSON.parse(sheetData);
                      }
                      
                      if (Array.isArray(sheetData) && sheetData.length > 0) {
                        const headers = sheetData[0].map((cell: any) => String(cell?.value || '').trim());
                        const concernedPersonIndex = headers.findIndex((h: string) => h.toLowerCase().includes('concerned person'));
                        
                        // Use standardized header mapping to find assigned person column
                        const headerRow = sheetData[0].map((cell: any) => cell);
                        const mappings = HeaderMapper.getAllColumnMappings(headerRow);
                        const assignedPersonIndex = mappings.assignedTo;
                        
                        if (assignedPersonIndex !== -1) {
                          // Create a new row with fake assignment
                          const newRow = new Array(headers.length).fill(null).map((_, index) => ({ value: '' }));
                          newRow[assignedPersonIndex] = { value: 'System User' };
                          
                          sheetData.push(newRow);
                          
                          // Update the workbook
                          const updatedWorkbook = {
                            ...workbookData,
                            sheets: workbookData.sheets.map((sheet: any, index: number) => 
                              index === 0 ? { ...sheet, data: JSON.stringify(sheetData) } : sheet
                            )
                          };
                          
                          await updateDoc(doc(db, 'excelWorkbooks', firstWorkbook.id), updatedWorkbook);
                          console.log('✅ Fake assignment added! Now refresh to see it.');
                          await onRefresh();
                        } else {
                          console.log('❌ No "Assigned Person" column found in first sheet (looking for: concerned person, assigned to, assigned, responsible)');
                        }
                      }
                    }
                  } else {
                    console.log('❌ No workbooks found');
                  }
                }}
                className="inline-flex items-center px-3 py-1.5 border border-green-300 rounded text-xs font-medium text-green-700 bg-green-50 hover:bg-green-100"
              >
                🧪 Add Test
              </button>
            </>
          )}
          {process.env.NODE_ENV === 'development' && (
            <button
              onClick={async () => {
                console.log('🔍 Debug: Checking all Excel workbooks...');
                const workbooksQuery = query(collection(db, 'excelWorkbooks'));
                const workbooksSnapshot = await getDocs(workbooksQuery);
                
                console.log('📊 Total workbooks found:', workbooksSnapshot.docs.length);
                
                workbooksSnapshot.docs.forEach((doc, docIndex) => {
                  const workbookData = doc.data();
                  console.log(`📋 Workbook ${docIndex + 1}:`, {
                    id: doc.id,
                    name: workbookData.workbookName,
                    sheetsCount: workbookData.sheets?.length || 0,
                    sheetNames: workbookData.sheets?.map((s: any) => s.name) || []
                  });
                  
                  if (workbookData.sheets) {
                    workbookData.sheets.forEach((sheet: any, sheetIndex: number) => {
                      console.log(`  📄 Sheet ${sheetIndex + 1}: ${sheet.name}`, {
                        dataRows: sheet.data?.length || 0,
                        dataType: Array.isArray(sheet.data) ? 'array' : typeof sheet.data,
                        headers: Array.isArray(sheet.data) && sheet.data[0] ? 
                          sheet.data[0].map((cell: any) => cell?.value) : []
                      });
                    });
                  }
                });
              }}
              className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              🔍 Debug
            </button>
          )} */}
        </div>
      </div>

      {/* Content */}
      {excelAssignedTasks.length === 0 ? (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">📝</div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Excel tasks assigned</h3>
          <p className="text-sm text-gray-500 mb-4">You don't have any tasks assigned from Excel workbooks yet.</p>
          <p className="text-sm text-gray-500 mb-4">Check console for debug information about data fetching.</p>
          <p className="text-sm text-gray-500">Ask your admin to assign tasks in the Excel editor.</p>
        </div>
      ) : (
        <div className="consolidated-excel-tasks-view">
          {(() => {
            // Consolidate all tasks into one view - same logic as UserDashboard
            const commonHeaders = ['Particulars', 'Concerned Person', 'Status', 'Priority', 'Due Date'];
            const consolidatedData = excelAssignedTasks.map(task => ({
              'Particulars': task.data?.['Particulars'] || task.data?.['Title'] || task.data?.['Name'] || '',
              'Concerned Person': task.data?.['Concerned Person'] || task.data?.['Assigned To'] || '',
              'Status': task.data?.['Status'] || '',
              'Priority': task.data?.['Priority'] || '',
              'Due Date': task.data?.['Due Date'] || task.data?.['Target Date'] || ''
            }));

            return (
              <div className="single-consolidated-task-card bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">📊 My Assigned Tasks</h3>
                      <p className="text-sm text-gray-600 mt-1">All {excelAssignedTasks.length} assigned tasks in one consolidated Excel sheet</p>
                    </div>
                    <div className="flex gap-2">
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        {excelAssignedTasks.length} Tasks
                      </span>
                    </div>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">📋 Task Summary</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {consolidatedData.slice(0, 6).map((taskData, index) => (
                        <div key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                          <div className="flex items-center gap-2 mb-2">
                            <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                              #{index + 1}
                            </span>
                            <span className="text-sm font-medium text-gray-900 truncate">
                              {taskData['Particulars'] || `Task ${index + 1}`}
                            </span>
                          </div>
                          <div className="space-y-1">
                            <div className="flex justify-between text-xs">
                              <span className="text-gray-600">Status:</span>
                              <span className={`font-medium ${
                                taskData['Status'] === 'COMPLETED' ? 'text-green-600' :
                                taskData['Status'] === 'IN-PROGRESS' ? 'text-blue-600' :
                                'text-yellow-600'
                              }`}>
                                {taskData['Status'] || 'TO-DO'}
                              </span>
                            </div>
                            <div className="flex justify-between text-xs">
                              <span className="text-gray-600">Priority:</span>
                              <span className={`font-medium ${
                                taskData['Priority'] === 'High' ? 'text-red-600' :
                                taskData['Priority'] === 'Medium' ? 'text-yellow-600' :
                                'text-green-600'
                              }`}>
                                {taskData['Priority'] || 'Medium'}
                              </span>
                            </div>
                            <div className="flex justify-between text-xs">
                              <span className="text-gray-600">Due:</span>
                              <span className="text-gray-900">{taskData['Due Date'] || 'No date'}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {excelAssignedTasks.length > 6 && (
                      <div className="mt-4 text-center">
                        <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-gray-100 text-gray-700">
                          +{excelAssignedTasks.length - 6} more tasks available in Excel editor
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="text-center">
                    <button
                      onClick={() => {
                        // Create a consolidated task for Excel editor
                        // Get headers from the first task or use common headers as fallback
                        const taskHeaders = excelAssignedTasks[0]?.headers || commonHeaders;
                        
                        const consolidatedTask = {
                          id: 'all_assigned_tasks',
                          headers: taskHeaders,
                          data: consolidatedData,
                          sheetName: 'My Assigned Tasks',
                          workbookId: 'consolidated',
                          workbookName: `My Assigned Tasks - ${excelAssignedTasks.length} Task${excelAssignedTasks.length > 1 ? 's' : ''}`,
                          totalTasks: excelAssignedTasks.length,
                          taskRows: excelAssignedTasks, // Pass original task structure instead of consolidated data
                          isFromDirectNotification: true
                        };
                        onViewExcel(consolidatedTask);
                      }}
                      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl"
                    >
                      <span className="mr-2">📊</span>
                      Open Full Excel Editor
                      <span className="ml-2">→</span>
                    </button>
                    <p className="text-sm text-gray-500 mt-2">
                      View and edit all {excelAssignedTasks.length} tasks in one unified Excel sheet
                    </p>
                  </div>
                </div>
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
};

const Tasks: React.FC = () => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [activeTab, setActiveTab] = useState<'individual' | 'team' | 'assigned' | 'excel-assigned' | 'daily-tasks'>('individual');
  const [currentView, setCurrentView] = useState<'list' | 'grid'>('list');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [userTeams, setUserTeams] = useState<any[]>([]);
  const [editingTask, setEditingTask] = useState<Task | null>(null);
  const [viewingTask, setViewingTask] = useState<Task | null>(null);
  const [viewingDocument, setViewingDocument] = useState<{url: string, name: string} | null>(null);
  const [excelAssignedTasks, setExcelAssignedTasks] = useState<any[]>([]);
  const [selectedExcelTask, setSelectedExcelTask] = useState<any>(null);
  const [showExcelEditor, setShowExcelEditor] = useState(false);
  const { user } = useAuth();

  // Fetch Excel assigned tasks from AWS S3 notifications
  const fetchExcelAssignedTasksFromNotifications = async () => {
    try {
      console.log('⚡ ULTRA FAST: Fetching DIRECT Excel notifications for user:', user?.uid);
      
      if (!user?.uid) {
        console.log('❌ No user UID available');
        return;
      }

      // Get DIRECT notifications from new system
      const directNotifications = await directExcelNotification.getUserExcelNotifications(user.uid);
      console.log('⚡ ULTRA FAST: Total DIRECT notifications found:', directNotifications.length);
      console.log('⚡ ULTRA FAST: Direct notifications:', directNotifications);
      
      // Convert DIRECT notifications to assigned tasks format
      const assignedTasks: any[] = [];
      
      directNotifications.forEach((notification, index) => {
        const excelData = notification.excelData || {};
        const headers = excelData.headers || [];
        const rows = excelData.rows || [];
        
        console.log(`⚡ DIRECT notification ${index + 1}:`, {
          id: notification.id,
          headers: headers,
          rowsCount: rows.length,
          sheetName: excelData.sheetName
        });
        
        // Process each row in the notification
        rows.forEach((rowData: string[], rowIndex: number) => {
          // Create task data from headers and row
          const taskData: { [key: string]: string } = {};
          headers.forEach((header: string, colIndex: number) => {
            taskData[header] = rowData[colIndex] || '';
          });
          
          console.log(`⚡ Task data for row ${rowIndex}:`, taskData);
          
          const task = {
            id: `${notification.id}_${rowIndex}`,
            headers: headers,
            data: taskData,
            sheetName: excelData.sheetName || 'Unknown Sheet',
            workbookId: excelData.workbookId || 'unknown',
            workbookName: `${excelData.sheetName || 'Excel'} - Assignment`,
            rowIndex: assignedTasks.length + 1,
            originalRowIndex: rowIndex,
            notificationId: notification.id,
            isFromDirectNotification: true,
            createdBy: notification.assignedBy || 'Unknown'
          };
          
          assignedTasks.push(task);
        });
      });
      
      console.log('⚡ ULTRA FAST: Converted to assigned tasks:', assignedTasks.length);
      console.log('⚡ ULTRA FAST: Final assigned tasks:', assignedTasks);
      
      // Remove duplicates based on data content
      const uniqueTasks = assignedTasks.filter((task, index, self) => {
        // Create unique key based on actual data, not notification ID
        const taskKey = JSON.stringify(task.data);
        return index === self.findIndex(t => JSON.stringify(t.data) === taskKey);
      });
      
      console.log(`⚡ ULTRA FAST: Removed duplicates: ${assignedTasks.length} → ${uniqueTasks.length}`);
      
      // Reverse to show LATEST FIRST
      const sortedTasks = uniqueTasks.reverse();
      
      console.log('⚡ ULTRA FAST: Sorted tasks (latest first)');
      setExcelAssignedTasks(sortedTasks);
      
    } catch (error) {
      console.error('❌ Error fetching DIRECT Excel notifications:', error);
      setExcelAssignedTasks([]);
    }
  };

  // Fetch Excel assigned tasks (original Firestore method)
  const fetchExcelAssignedTasks = async () => {
    try {
      console.log('🔍 Fetching Excel assigned tasks for user:', user?.uid);
      console.log('👤 User details:', {
        uid: user?.uid,
        displayName: user?.displayName,
        email: user?.email
      });

      // Fetch from excelWorkbooks collection
      const workbooksQuery = query(collection(db, 'excelWorkbooks'));
      const workbooksSnapshot = await getDocs(workbooksQuery);
      
      console.log('📊 Total workbooks found:', workbooksSnapshot.docs.length);
      
      const assignedTasks: any[] = [];
      
      workbooksSnapshot.docs.forEach((doc, docIndex) => {
        const workbookData = doc.data();
        console.log(`📋 Workbook ${docIndex + 1}:`, {
          id: doc.id,
          name: workbookData.workbookName,
          sheetsCount: workbookData.sheets?.length || 0
        });
        
        if (workbookData.sheets && Array.isArray(workbookData.sheets)) {
          workbookData.sheets.forEach((sheet: any, sheetIndex: number) => {
            console.log(`  📄 Sheet ${sheetIndex + 1}: ${sheet.name}`, {
              dataRows: sheet.data?.length || 0,
              dataType: Array.isArray(sheet.data) ? 'array' : typeof sheet.data,
              headers: Array.isArray(sheet.data) && sheet.data[0] ? 
                sheet.data[0].map((cell: any) => cell?.value) : []
            });
            
            // Handle different data formats
            let sheetData = sheet.data;
            
            // If data is a JSON string, parse it
            if (typeof sheetData === 'string') {
              try {
                sheetData = JSON.parse(sheetData);
                console.log(`    🔄 Parsed JSON data for sheet ${sheet.name}`);
              } catch (error) {
                console.log(`    ⚠️ Failed to parse JSON data for sheet ${sheet.name}:`, error);
                return;
              }
            }
            
            if (sheetData && Array.isArray(sheetData) && sheetData.length > 1) {
              // Get headers from first row - ensure it's an array
              const firstRow = sheetData[0];
              if (!Array.isArray(firstRow)) {
                console.log(`    ⚠️ First row is not an array:`, firstRow);
                return;
              }
              
              const headers = firstRow.map((cell: any) => String(cell?.value || '').trim());
              console.log(`    📋 Headers:`, headers);
              
              // Check each data row for assignments
              sheetData.slice(1).forEach((row: any[], rowIndex: number) => {
                if (!Array.isArray(row)) {
                  console.log(`    ⚠️ Row ${rowIndex + 1} is not an array:`, row);
                  return;
                }
                const rowData: { [key: string]: any } = {};
                let isAssignedToUser = false;
                
                console.log(`    🔍 Checking row ${rowIndex + 1}:`, row.map(cell => cell?.value));
                
                // Map row data to headers
                row.forEach((cell: any, colIndex: number) => {
                  const header = headers[colIndex];
                  if (header) {
                    rowData[header] = cell?.value || '';
                    
                    // Check if this row is assigned to current user
                    const cellValue = String(cell?.value || '').toLowerCase();
                    const headerLower = header.toLowerCase();
                    
                    // Check multiple assignment fields
                    const isAssignmentField = 
                      headerLower.includes('concerned person') || 
                      headerLower.includes('concerned_person') ||
                      headerLower.includes('assigned to') ||
                      headerLower.includes('assigned_to') ||
                      headerLower.includes('assigned') ||
                      headerLower.includes('responsible') ||
                      headerLower.includes('assignee');
                    
                    if (isAssignmentField) {
                      console.log(`      🔍 Checking assignment field "${header}": "${cellValue}"`);
                      
                      const isAssigned = 
                        cellValue.includes(user?.uid || '') || 
                        cellValue.includes(user?.displayName?.toLowerCase() || '') ||
                        cellValue.includes(user?.email?.toLowerCase() || '') ||
                        cellValue.includes(user?.displayName || '') ||
                        cellValue.includes(`${user?.displayName} (${user?.email})`.toLowerCase()) ||
                        cellValue.includes(`${user?.displayName} (${user?.email})`) ||
                        cellValue.includes(`(${user?.email})`) ||
                        cellValue.includes(`(${user?.email?.toLowerCase()})`);
                      
                      console.log(`      ✅ Assignment check:`, {
                        cellValue,
                        userUid: user?.uid,
                        userDisplayName: user?.displayName?.toLowerCase(),
                        userEmail: user?.email?.toLowerCase(),
                        isAssigned,
                        header: header,
                        rowIndex: rowIndex + 1
                      });
                      
                      if (isAssigned) {
                        isAssignedToUser = true;
                        console.log(`✅ Found assignment in field "${header}": "${cellValue}"`);
                      }
                    }
                  }
                });
                
                if (isAssignedToUser) {
                  console.log(`🎯 Adding assigned task:`, {
                    id: `${doc.id}_${sheet.name}_${rowIndex}`,
                    sheetName: sheet.name,
                    workbookId: doc.id,
                    headers: headers,
                    rowData: rowData,
                    dataKeys: Object.keys(rowData),
                    dataValues: Object.values(rowData),
                    assignmentFields: Object.entries(rowData).filter(([key, value]) => {
                      const keyLower = key.toLowerCase();
                      const valueStr = String(value || '').toLowerCase();
                      return (keyLower.includes('concerned person') || 
                              keyLower.includes('assigned to') || 
                              keyLower.includes('responsible') ||
                              keyLower.includes('assignee')) &&
                             (valueStr.includes(user?.uid || '') || 
                              valueStr.includes(user?.displayName?.toLowerCase() || '') ||
                              valueStr.includes(user?.email?.toLowerCase() || ''));
                    })
                  });
                  
                  assignedTasks.push({
                    id: `${doc.id}_${sheet.name}_${rowIndex}`,
                    headers: headers,
                    data: rowData,
                    sheetName: sheet.name,
                    workbookId: doc.id,
                    workbookName: workbookData.workbookName || 'Excel Workbook',
                    rowIndex: rowIndex + 1, // +1 because we sliced the first row (headers)
                    originalRowIndex: rowIndex
                  });
                } else {
                  console.log(`❌ Row ${rowIndex + 1} not assigned to user - skipping`);
                }
              });
            }
          });
        }
      });
      
      console.log('📋 Found Excel assigned tasks:', assignedTasks.length);
      console.log('📊 Assigned tasks details:', assignedTasks.map(t => ({
        id: t.id,
        sheetName: t.sheetName,
        workbookName: t.workbookName,
        headers: t.headers,
        dataKeys: Object.keys(t.data)
      })));
      console.log('✅ Excel assigned tasks fetched:', assignedTasks.length);
      console.log('📊 Summary:', {
        totalWorkbooks: workbooksSnapshot.docs.length,
        totalTasksFound: assignedTasks.length,
        userInfo: {
          uid: user?.uid,
          displayName: user?.displayName,
          email: user?.email
        }
      });
      
      // Debug: Show all assignment fields found in all workbooks
      console.log('🔍 DEBUG: All assignment fields found:');
      workbooksSnapshot.docs.forEach((doc, docIndex) => {
        const workbookData = doc.data();
        if (workbookData.sheets && Array.isArray(workbookData.sheets)) {
          workbookData.sheets.forEach((sheet: any) => {
            let sheetData = sheet.data;
            if (typeof sheetData === 'string') {
              try {
                sheetData = JSON.parse(sheetData);
              } catch (error) {
                return;
              }
            }
            if (sheetData && Array.isArray(sheetData) && sheetData.length > 1) {
              const headers = sheetData[0].map((cell: any) => String(cell?.value || '').trim());
              const assignmentHeaders = headers.filter((h: string) => 
                h.toLowerCase().includes('concerned person') || 
                h.toLowerCase().includes('assigned to') ||
                h.toLowerCase().includes('responsible') ||
                h.toLowerCase().includes('assignee')
              );
              if (assignmentHeaders.length > 0) {
                console.log(`📋 Workbook ${docIndex + 1}, Sheet "${sheet.name}":`, {
                  assignmentHeaders,
                  allHeaders: headers
                });
                
                // Show sample data from assignment columns
                console.log(`📊 Sample data from assignment columns:`);
                sheetData.slice(1, 4).forEach((row: any[], rowIndex: number) => {
                  if (Array.isArray(row)) {
                    const rowData: { [key: string]: any } = {};
                    row.forEach((cell: any, colIndex: number) => {
                      const header = headers[colIndex];
                      if (header && assignmentHeaders.includes(header)) {
                        rowData[header] = cell?.value || '';
                      }
                    });
                    if (Object.keys(rowData).length > 0) {
                      console.log(`  Row ${rowIndex + 2}:`, rowData);
                    }
                  }
                });
              }
            }
          });
        }
      });
      
      setExcelAssignedTasks(assignedTasks);
    } catch (error) {
      console.error('❌ Error fetching Excel assigned tasks:', error);
    }
  };

  // Handle viewing Excel task
  const handleViewExcel = (task: any) => {
    console.log('📊 Opening Excel editor for task:', {
      id: task.id,
      sheetName: task.sheetName,
      workbookId: task.workbookId,
      rowIndex: task.rowIndex,
      data: task.data
    });
    setSelectedExcelTask(task);
    setShowExcelEditor(true);
  };

  // Fetch Excel tasks when excel-assigned tab is active
  useEffect(() => {
    if (activeTab === 'excel-assigned' && user) {
      // Try AWS S3 notifications first, fallback to Firestore
      fetchExcelAssignedTasksFromNotifications();
    }
  }, [activeTab, user]);

  // Auto-refresh Excel assigned tasks every 10 seconds when tab is active
  useEffect(() => {
    if (activeTab === 'excel-assigned' && user) {
      const interval = setInterval(() => {
        console.log('🔄 Auto-refreshing Excel assigned tasks...');
        fetchExcelAssignedTasksFromNotifications();
      }, 10000); // Refresh every 10 seconds for faster updates

      return () => clearInterval(interval);
    }
  }, [activeTab, user]);

  // Listen for Excel data saved events to refresh immediately
  useEffect(() => {
    const handleExcelDataSaved = () => {
      console.log('📢 Excel data saved event received, refreshing assigned tasks...');
      if (activeTab === 'excel-assigned') {
        fetchExcelAssignedTasksFromNotifications();
      }
    };

    window.addEventListener('excelDataSaved', handleExcelDataSaved);
    return () => window.removeEventListener('excelDataSaved', handleExcelDataSaved);
  }, [activeTab]);

  useEffect(() => {
    if (!user) return;

    const fetchUserTeams = async () => {
      try {
        // First, get user's teams from user document
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        const userData = userSnap.data();

        if (userData?.teams && userData.teams.length > 0) {
          // Fetch team details for each team ID
          const teamPromises = userData.teams.map(async (teamId: string) => {
            const teamRef = doc(db, 'teams', teamId);
            const teamSnap = await getDoc(teamRef);
            if (teamSnap.exists()) {
              return { id: teamId, ...teamSnap.data() };
            }
            return null;
          });
          
          const teamsData = (await Promise.all(teamPromises)).filter(Boolean);
          setUserTeams(teamsData);
        } else {
          // Fallback: try to find teams where user is a member
          const teamsQuery = query(
            collection(db, 'teams'),
            where('members', 'array-contains-any', [user.uid, { uid: user.uid }])
          );

          const snapshot = await getDocs(teamsQuery);
          const teams = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setUserTeams(teams);
        }
      } catch (error) {
        console.error('Error fetching user teams:', error);
        setUserTeams([]);
      }
    };

    fetchUserTeams();
  }, [user]);

  useEffect(() => {
    if (!user) return;

    let unsubscribe: (() => void) | undefined;
    let isMounted = true;

    if (activeTab === 'individual') {
      // For individual tab, we need to fetch tasks created by user AND tasks assigned to user
      // Since Firestore doesn't support OR queries, we'll make two separate queries
      const createdByUserQuery = query(
        collection(db, 'tasks'),
        where('createdBy', '==', user.uid),
        where('taskType', '==', 'individual')
      );
      
      const assignedToUserQuery = query(
        collection(db, 'tasks'),
        where('assignedTo', '==', user.uid)
      );
      
      // Listen to both queries and combine results
      let createdTasks: Task[] = [];
      let assignedTasks: Task[] = [];
      
      const unsubscribeCreated = onSnapshot(createdByUserQuery, (snapshot) => {
        if (!isMounted) return;
        createdTasks = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as Task[];
        
        // Combine and deduplicate tasks
        const allTasks = [...createdTasks, ...assignedTasks];
        const uniqueTasks = allTasks.filter((task, index, self) => 
          index === self.findIndex(t => t.id === task.id)
        );
        setTasks(uniqueTasks);
      });
      
      const unsubscribeAssigned = onSnapshot(assignedToUserQuery, (snapshot) => {
        if (!isMounted) return;
        assignedTasks = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as Task[];
        
        // Combine and deduplicate tasks
        const allTasks = [...createdTasks, ...assignedTasks];
        const uniqueTasks = allTasks.filter((task, index, self) => 
          index === self.findIndex(t => t.id === task.id)
        );
        setTasks(uniqueTasks);
      });
      
      unsubscribe = () => {
        unsubscribeCreated();
        unsubscribeAssigned();
      };
      
    } else if (activeTab === 'assigned') {
      // For assigned tab, fetch tasks assigned to the current user
      const tasksQuery = query(
        collection(db, 'tasks'),
        where('assignedTo', '==', user.uid)
      );
      
      unsubscribe = onSnapshot(tasksQuery, (snapshot) => {
        if (!isMounted) return;
        
        try {
          const tasksData = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          })) as Task[];
          setTasks(tasksData);
        } catch (error) {
          console.error('Error processing tasks:', error);
        }
      }, (error) => {
        console.error('Error listening to tasks:', error);
      });
      
    } else {
      // Team tasks - get tasks from user's teams
      const teamIds = userTeams.map(team => team.id);
      if (teamIds.length > 0) {
        const tasksQuery = query(
          collection(db, 'tasks'),
          where('teamId', 'in', teamIds),
          where('taskType', '==', 'team')
        );
        
        unsubscribe = onSnapshot(tasksQuery, (snapshot) => {
          if (!isMounted) return;
          
          try {
            const tasksData = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            })) as Task[];
            setTasks(tasksData);
          } catch (error) {
            console.error('Error listening to tasks:', error);
          }
        }, (error) => {
          console.error('Error listening to tasks:', error);
        });
      }
    }

    // Return cleanup function
    return () => {
      isMounted = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [user, activeTab, userTeams]);

  const handleUpdateTaskStatus = async (taskId: string, newStatus: Task['status']) => {
    try {
      await updateDoc(doc(db, 'tasks', taskId), {
        status: newStatus
      });
    } catch (error) {
      console.error('Error updating task status:', error);
    }
  };

  const handleDeleteTask = async (taskId: string) => {
    try {
      await deleteDoc(doc(db, 'tasks', taskId));
    } catch (error) {
      console.error('Error deleting task:', error);
    }
  };

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high': return 'bg-red-100 text-red-800 border-red-200';
      case 'medium': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'low': return 'bg-green-100 text-green-800 border-green-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'COMPLETED': return 'bg-green-100 text-green-800 border-green-200';
      case 'IN-PROGRESS': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'TO-DO': return 'bg-gray-100 text-gray-800 border-gray-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  // Tasks are now filtered at the query level, so we can use them directly
  const filteredTasks = tasks;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header - Responsive */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center py-4 sm:py-6 gap-4">
            <div className="flex-1 min-w-0">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Tasks</h1>
              <p className="mt-1 text-sm text-gray-500">
                Manage your {activeTab === 'individual' ? 'personal and assigned' : activeTab === 'assigned' ? 'assigned' : 'team'} tasks
              </p>
            </div>
            {/* <button
              onClick={() => setShowCreateModal(true)}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl touch-target"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span className="hidden sm:inline">Create Task</span>
              <span className="sm:hidden">Create</span>
            </button> */}
          </div>
        </div>
      </div>

      {/* Tab Navigation - Responsive */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-1 sm:space-x-8 overflow-x-auto scrollbar-thin">
            {/* <button
              onClick={() => setActiveTab('individual')}
              className={`py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap touch-target ${
                activeTab === 'individual'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span className="hidden sm:inline">Individual Tasks</span>
              <span className="sm:hidden">Individual</span>
            </button> */}
            {/* <button
              onClick={() => setActiveTab('team')}
              className={`py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap touch-target ${
                activeTab === 'team'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span className="hidden sm:inline">Team Tasks</span>
              <span className="sm:hidden">Team</span>
            </button> */}
            {/* <button
              onClick={() => setActiveTab('assigned')}
              className={`py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap touch-target ${
                activeTab === 'assigned'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-2a3 3 0 00-5.356-1.857M15 21H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 21H2v-2a3 3 0 015.356-1.857M7 21v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span className="hidden sm:inline">Assigned Tasks</span>
              <span className="sm:hidden">Assigned</span>
            </button> */}
            <button
              onClick={() => setActiveTab('excel-assigned')}
              className={`py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap touch-target ${
                activeTab === 'excel-assigned'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h2a2 2 0 002-2z" />
              </svg>
              <span className="hidden sm:inline"> Assigned Tasks</span>
              <span className="sm:hidden">Excel</span>
            </button>
            <button
              onClick={() => setActiveTab('daily-tasks')}
              className={`py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap touch-target ${
                activeTab === 'daily-tasks'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span className="hidden sm:inline">Daily Tasks</span>
              <span className="sm:hidden">Daily</span>
            </button>
          </div>
        </div>
      </div>

      {/* Task List Manager */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeTab === 'excel-assigned' ? (
          <ExcelAssignTasksContent 
            excelAssignedTasks={excelAssignedTasks}
            onViewExcel={handleViewExcel}
            onRefresh={fetchExcelAssignedTasksFromNotifications}
            user={user}
            fetchExcelAssignedTasksFromNotifications={fetchExcelAssignedTasksFromNotifications}
          />
        ) : activeTab === 'daily-tasks' ? (
          <DailyTaskReport />
        ) : (
          <TaskListManager
            tasks={filteredTasks}
            viewType={activeTab}
            onViewChange={setCurrentView}
            currentView={currentView}
          />
        )}
      </div>

      {/* Tasks Grid View */}
      {currentView === 'grid' && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
          {filteredTasks.length === 0 ? (
            <div className="text-center py-12">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">No tasks</h3>
                             <p className="mt-1 text-sm text-gray-500">
                 Get started by creating a new {activeTab === 'individual' ? 'personal or assigned' : activeTab === 'assigned' ? 'assigned' : 'team'} task.
               </p>
              <div className="mt-6">
                {/* <button
                  onClick={() => setShowCreateModal(true)}
                  className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  Create Task
                </button> */}
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredTasks.map((task) => (
                <div key={task.id} className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="text-lg font-medium text-gray-900">{task.title}</h3>
                        <div className="flex items-center space-x-2 mt-1">
                                                     <span className="text-sm text-gray-500">
                             {task.teamId ? 'Team Task' : 'Individual Task'}
                           </span>
                          {activeTab === 'individual' && (
                            <>
                              <span className="text-gray-400">•</span>
                              <span className={`text-xs px-2 py-1 rounded-full ${
                                task.assignedTo === user?.uid 
                                  ? 'bg-blue-100 text-blue-800' 
                                  : 'bg-green-100 text-green-800'
                              }`}>
                                {task.assignedTo === user?.uid ? 'Assigned to you' : 'Created by you'}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => setViewingTask(task)}
                          className="text-gray-400 hover:text-green-500 transition-colors"
                          title="View task details"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </button>
                        <button
                          onClick={() => setEditingTask(task)}
                          className="text-gray-400 hover:text-blue-500 transition-colors"
                          title="Edit task"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                        </button>
                        <button
                          onClick={() => task.id && handleDeleteTask(task.id)}
                          className="text-gray-400 hover:text-red-500 transition-colors"
                          title="Delete task"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    
                    {task.description && (
                      <p className="text-gray-600 mb-4 line-clamp-3">{task.description}</p>
                    )}
                    
                    <div className="flex flex-wrap gap-2 mb-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getPriorityColor(task.priority)}`}>
                        {task.priority.charAt(0).toUpperCase() + task.priority.slice(1)} Priority
                      </span>
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(task.status)}`}>
                        {task.status.replace('-', ' ').charAt(0).toUpperCase() + task.status.replace('-', ' ').slice(1)}
                      </span>
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border-gray-200">
                        {task.category}
                      </span>
                    </div>
                    
                    {task.dueDate && (
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        Due: {new Date(task.dueDate).toLocaleDateString()}
                      </div>
                    )}

                    {/* Attachments */}
                    {task.attachments && task.attachments.length > 0 && (
                      <div className="mb-4">
                        <div className="flex items-center space-x-2 mb-2">
                          <span className="text-sm font-medium text-gray-700">📎 Attachments ({task.attachments.length})</span>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {task.attachments.slice(0, 2).map((attachment, index) => (
                            <div key={index} className="flex items-center space-x-1 bg-gray-50 rounded px-2 py-1">
                              <span className="text-xs">📎</span>
                              <span className="text-xs text-gray-600 truncate max-w-16">
                                {attachment.name}
                              </span>
                            </div>
                          ))}
                          {task.attachments.length > 2 && (
                            <span className="text-xs text-gray-500">
                              +{task.attachments.length - 2} more
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    
                    <div className="flex items-center justify-between">
                      <select
                        value={task.status}
                        onChange={(e) => task.id && handleUpdateTaskStatus(task.id, e.target.value as Task['status'])}
                        className="text-sm border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="TO-DO">To Do</option>
                        <option value="IN-PROGRESS">In Progress</option>
                        <option value="COMPLETED">Completed</option>
                      </select>
                      
                      <div className="text-xs text-gray-400">
                        {task.createdAt?.toDate ? 
                          task.createdAt.toDate().toLocaleDateString() : 
                          new Date().toLocaleDateString()
                        }
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Create Task Modal */}
      {showCreateModal && (
        <AddTaskForm
          taskToEdit={null}
          onClose={() => setShowCreateModal(false)}
          userTeams={userTeams}
        />
      )}

      {/* Edit Task Modal */}
      {editingTask && (
        <AddTaskForm
          taskToEdit={editingTask}
          onClose={() => setEditingTask(null)}
          userTeams={userTeams}
        />
      )}

      {/* Excel Detail View - Full Screen */}
      {viewingTask && (
        <ExcelDetailView
          item={viewingTask}
          itemType="task"
          onClose={() => setViewingTask(null)}
          onEdit={() => {
            setEditingTask(viewingTask);
            setViewingTask(null);
          }}
          onDelete={async () => {
            if (window.confirm('Are you sure you want to delete this task?')) {
              try {
                if (viewingTask.id) {
                  await deleteDoc(doc(db, 'tasks', viewingTask.id));
                  setTasks(prev => prev.filter(task => task.id !== viewingTask.id));
                  setViewingTask(null);
                }
              } catch (error) {
                console.error('Error deleting task:', error);
                alert('Error deleting task. Please try again.');
              }
            }
          }}
        />
      )}

      {/* Document Viewer Modal */}
      {viewingDocument && (
        <DocumentViewer
          documentUrl={viewingDocument.url}
          fileName={viewingDocument.name}
          onClose={() => setViewingDocument(null)}
        />
      )}

      {/* Excel Editor Modal */}
      {showExcelEditor && selectedExcelTask && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full h-full max-w-7xl max-h-screen m-4 flex flex-col">
            <div className="flex justify-between items-center p-4 border-b">
              <div>
                <h2 className="text-xl font-bold text-gray-900">
                  📊 Excel Editor - {selectedExcelTask.sheetName}
                </h2>
                <p className="text-sm text-gray-600 mt-1">
                  Highlighting assigned row {selectedExcelTask.rowIndex} - {selectedExcelTask.data?.Name || selectedExcelTask.data?.Title || 'Task'}
                </p>
              </div>
              <button
                onClick={() => setShowExcelEditor(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                ❌ Close
              </button>
            </div>
            <div className="flex-1 overflow-hidden">
              <FullExcelEditor 
                folderId={selectedExcelTask.workbookId || 'consolidated'}
                folderName={selectedExcelTask.sheetName || 'My Assigned Tasks'}
                onClose={() => setShowExcelEditor(false)}
                highlightRow={selectedExcelTask.rowIndex}
                assignedTaskData={excelAssignedTasks}
                isConsolidatedView={true}
                allTaskRows={excelAssignedTasks}
                headers={selectedExcelTask.headers || excelAssignedTasks[0]?.headers || ['Particulars', 'Concerned Person', 'Status', 'Priority', 'Due Date', 'Attachment']}
                isReadOnly={true}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tasks; 